import React from 'react';

import PropTypes from 'prop-types';
import { Step, Icon } from 'semantic-ui-react';

import { stepType } from './ConnectionSteps.types';

import './ConnectionSteps.scss';

const propTypes = {
  steps: PropTypes.arrayOf(stepType).isRequired,
  getStepGroupProps: PropTypes.func,
};

const defaultProps = {
  getStepGroupProps: (props) => props,
};

export default function ConnectionSteps({ steps, getStepGroupProps, ...stepGroupProps }) {
  const stepGroupFinalProps = getStepGroupProps({ ...stepGroupProps, stackable: 'tablet' });

  return (
    <div className="business-profile-connection-steps">
      <Step.Group {...stepGroupFinalProps}>
        {steps.map(({ id, active, completed, icon, title, description }) => (
          <Step key={id} active={active} completed={completed}>
            {icon && <Icon name={icon} />}
            <Step.Content>
              <Step.Title>{title}</Step.Title>
              <Step.Description>{description}</Step.Description>
            </Step.Content>
          </Step>
        ))}
      </Step.Group>
    </div>
  );
}

ConnectionSteps.propTypes = propTypes;
ConnectionSteps.defaultProps = defaultProps;
